<template>
    <component :is="tag">
        <slot
            :step="step"
            :brief="brief"
            :contact="contact"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-step="patchStep"
            :is-loading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :is-patching-brief="isPatchingBrief"
            :is-additional-order="isAdditionalOrder"
            :countries="countries"
            :provinces="provinces"
            :loading-countries="loadingCountries"
            :loading-provinces="loadingProvinces"
            :country-updated="countryUpdated"
            :errors="errors"
            :errorMessage="errorMessage"
        />
    </component>
</template>

<script>
    import BaseActivationBriefStepMixin from "../mixins/BaseActivationBriefStepMixin";
    import {NAME_SHIPPING_INFO} from "../../../constants/activation-brief-steps";

    export default {
        name: "ActivationBriefShippingProvider",
        props: {
          isAdditionalOrder: {
              type:    Boolean,
              default: false,
          }
        },
        mixins: [
            BaseActivationBriefStepMixin,
        ],
        computed: {
            step() {
                return this.steps[NAME_SHIPPING_INFO]
            },
        },
        created() {
            this.isLoading = true;

            this.loadCountries()
                .then(() => this.loadContact()
                    .then(() => {
                        return Promise.all([
                            this.loadActivationBrief()
                        ]);
                    })
                    .then(() => {
                        this.initStep(this.step);
                    })
                    .catch(error => this.handleHttpError(error))
                    .then(() => {
                        this.isLoading = false;
                    })
                );
        }
    }
</script>
